import type { UserAttributes, UserStoryAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type GroupBy,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryLimitToSQL,
  queryOrderToSQL,
} from './common'
import UserQ from './UserQ'

const UserStoryQ = {
  ...makeQueryModelV2<UserStoryAttributes>('user_story')([
    'id',
    'title',
    'body',
    'role',
    'clap_count',
    'user_id',
    'created_at',
    'rejected_at',
    'published_at',
  ]),

  where: (
    {
      id,
      published,
      groupBy = null,
      order = null,
      limit = null,
    }: {
      id?: number
      published?: boolean
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      limit?: number | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<UserAttributes> =>
    SQL` FROM ${UserStoryQ}
    WHERE
    ${id != null ? SQL`${UserStoryQ.id} = ${id} AND` : SQL``}
    ${
      published != null
        ? SQL`${UserStoryQ.published_at} IS${published ? SQL` NOT` : SQL``} NULL AND`
        : SQL``
    }
    ${customWhere != null ? customWhere : SQL`TRUE`}
    ${queryGroupByToSQL(groupBy)} ${queryOrderToSQL(order)}
    ${queryLimitToSQL(limit)}
  `,

  getUser: (): SQLFragment<UserAttributes> =>
    SQL`${UserQ.where({
      id: UserStoryQ.user_id,
    })}`,

  wherePublished: (): SQLFragment<UserAttributes> =>
    UserStoryQ.where(
      { order: [[UserStoryQ.created_at, 'desc']] },
      SQL`${UserStoryQ.published_at} IS NOT NULL`
    ),

  whereNeedsReview: (): SQLFragment<UserAttributes> =>
    UserStoryQ.where(
      { order: [[UserStoryQ.created_at, 'asc']] },
      SQL`${UserStoryQ.published_at} IS NULL AND ${UserStoryQ.rejected_at} IS NULL`
    ),
}

export default UserStoryQ
